export default __webpack_public_path__ + "static/1345-3a76cfe126489df827a5be5d5d2d8ca9.gif";